import { LauncherPositions } from '@gamiphy/bl/theme';
import { ThemeDto } from '@coretava/api/core-service';

export const getMobileFramePosition = (launcherOffset: number, theme: ThemeDto): {
  left?: number | string,
  right?: number,
  top?: number | string,
  bottom?: number,
  width?: string,
  transform?: string
} | undefined => {
  const launcherSize = theme.launcher.size ?? 60;
  switch (theme.launcher.position.mobile) {
    case LauncherPositions.bottom:
    case LauncherPositions.bottomLeft:
    case LauncherPositions.bottomRight:
      return {
        left: '50%',
        transform: 'translateX(-50%)',
        bottom: launcherOffset + launcherSize + 20,
      };
    case LauncherPositions.top:
    case LauncherPositions.topRight:
    case LauncherPositions.topLeft:
      return {
        top: launcherOffset + launcherSize + 20,
        left: '50%',
        transform: 'translateX(-50%)',
      };
    case LauncherPositions.right:
      return {
        right: launcherOffset,
        top: '50%',
        transform: `translateY(calc(-50% + ${2 * (launcherSize + 20)}px))`,
      };
    case LauncherPositions.left:
      return {
        left: launcherOffset,
        top: '50%',
        transform: `translateY(calc(-50% + ${2 * (launcherSize + 20)}px))`,
      };
    default:
      return undefined;
  }
};
